import { useState, useEffect } from 'react'
import 'react-day-picker/lib/style.css'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles, useTheme } from '@material-ui/styles'
import LoadingOverlay from 'react-loading-overlay'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { useDispatch, useSelector } from 'react-redux'

import { useConfirm } from 'material-ui-confirm'

import jwt_decode from 'jwt-decode'
import { userRequest, logout } from '../../store/modules/user/actions'

import { Sidebar, Topbar, Footer } from './components'
import { browserHistory as history } from 'App'

LoadingOverlay.propTypes = undefined

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64
    }
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    height: '100%'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  },
  inner: {
    minWidth: 350,
    minHeight: 250,
    marginLeft: 45
  },
  inputForm: {
    width: 100,
    minWidth: 150,
    marginBottom: 15,
    marginRight: 5
  }
}))

export default function Owner({ children }) {
  const dispatch = useDispatch()

  const user = useSelector(state => state.user.user)
  const error = useSelector(state => state.error.error)

  const inputLoading = useSelector(state => state.input.loading)
  const userLoading = useSelector(state => state.user.loading)
  const goalLoading = useSelector(state => state.goal.loading)
  const reportLoading = useSelector(state => state.report.loading)

  const classes = useStyles()
  const theme = useTheme()
  const confirm = useConfirm()
  const token = window.localStorage.getItem('@NeoPro:token')

  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  })

  const [openSidebar, setOpenSidebar] = useState(false)

  useEffect(() => {
    if (error) {
      if (
        error?.error?.friendlyMsg ===
        'A meta ainda não foi definida para esse mês.'
      )
        return

      confirm({
        title: 'Ops!',
        description:
          error.error && error.error.friendlyMsg
            ? error.error.friendlyMsg
            : JSON.stringify(error),
        confirmationText: 'Ok!',
        cancellationText: 'Fechar'
      })
        .then(() => {})
        .catch(() => {})
    }
  }, [error])

  const handleSidebarOpen = () => {
    setOpenSidebar(true)
  }

  const handleSidebarClose = () => {
    setOpenSidebar(false)
  }

  const logoff = async (redirect = true) => {
    const token = window.localStorage.getItem('@NeoPro:token')

    if (token) {
      const removeTokenPromise = new Promise(resolve => {
        resolve(window.localStorage.removeItem('@NeoPro:token'))
      })
      removeTokenPromise.then(() => {
        dispatch(logout())
        if (redirect) history.push('/login')
      })
    } else {
      dispatch(logout())
      history.push('/login')
    }
  }

  // Verifica se user está logado
  useEffect(() => {
    if (!user._id && token) {
      const user = jwt_decode(token)
      dispatch(userRequest(user.id, token))
    } else if (!token) {
      logoff()
    }
  }, [token, user])

  return (
    <LoadingOverlay
      active={userLoading || inputLoading || goalLoading || reportLoading}
      spinner
    >
      <div
        className={clsx({
          [classes.root]: true
        })}
      >
        <Topbar
          onSidebarOpen={handleSidebarOpen}
          onLogoff={logoff}
          storeName={user.name.first}
        />
        <Sidebar
          onClose={handleSidebarClose}
          open={openSidebar}
          onOpen={handleSidebarOpen}
          variant='temporary'
          user={user}
          onLogoff={logoff}
        />
        <main
          className={classes.content}
          style={{
            ...(isDesktop && {
              height: '100%',
              maxHeight: 'calc(100vh - 64px)',
              overflowY: 'auto'
            })
          }}
        >
          {children}
          <Footer />
        </main>
      </div>
    </LoadingOverlay>
  )
}

Owner.propTypes = {
  children: PropTypes.node
}
